import React from 'react';

import ListView from '../shared/lists/ListView';
import ServiceCallItem from './ServiceCallItem';
import CustomTh from '../shared/table/CustomTh';
import useBreakpoints from '../../utilities/useBreakpoints';

const ServiceCallList = ({
    addItem,
    canAdd,
    data: { items },
    editItem,
    fetchData
}) => {
    const { isBreakpoint } = useBreakpoints();

    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <CustomTh hide="sm" width="100px" content="Call Date" />
                <CustomTh width={isBreakpoint('md') ? '170px' : ''} content="Repair Date" />
                <CustomTh style={{ textAlign: 'center' }} hide="sm" content="Description" />
                <CustomTh width="90px" />
            </tr>
        </thead>
    );

    const listItems = items && items.map((item) =>
        <ServiceCallItem
            key={item.id}
            item={item}
            fetchData={fetchData}
            editItem={() => editItem(item.id)}
        />
    );

    return (
        <ListView
            items={listItems}
            tableHead={tableHead}
            canAdd={canAdd}
            itemName="Repair"
            addItem={addItem}
        />
    );
}

export default ServiceCallList;